import React, { useState, useMemo, useEffect } from "react";
import trackStore from "@/stores/clip/trackState";
import playerStore from "@/stores/clip/player";
import { getId } from "@/utils/tool";
import { Button, Slider } from "@arco-design/web-react";
import { observer } from "mobx-react";
import { IconDelete, IconRedo, IconUndo } from "@arco-design/web-react/icon";
import useUndoRedo from "../hooks/useUndoRedo";
// import {
//   UndoIcon,
//   RedoIcon,
//   SplitIcon,
//   DeleteIcon,
//   SubIcon,
//   AddIcon,
// } from "@/icons"; // 假设图标组件已导入

interface ToolbarProps {
  value?: number; // 默认值为 30
  onChange?: (val: number) => void; // 更新 value 的回调
}

const Toolbar: React.FC<ToolbarProps> = ({ value = 30, onChange }) => {
  const { state, setState, undo, redo, canUndo, canRedo } = useUndoRedo(
    trackStore.trackList
  );
  // 图标配置
  const icons = useMemo(
    () => [
      {
        title: "撤销",
        icon: IconUndo,
        action: "undo",
      },
      {
        title: "前进",
        icon: IconRedo,
        action: "redo",
      },
      // {
      //   title: "分割",
      //   disable:
      //     trackStore.selectGroupItem.line === -1 &&
      //     trackStore.selectGroupItem.index === -1,
      //   // icon: SplitIcon,
      // },
      {
        title: "删除",
        disable:
          trackStore.selectGroupItem.line === -1 &&
          trackStore.selectGroupItem.index === -1,
        icon: IconDelete,
        action: "delete",
      },
    ],
    [trackStore.selectGroupItem]
  );

  // Slider 配置
  const sliderProps = {
    size: "small",
    step: 10,
    max: 70,
    min: 0,
  };

  // SVG 样式
  const svgStyle = {
    fontSize: "1.75rem",
    padding: "0.25rem",
    boxSizing: "content-box",
  };

  // 修改缩放比例
  const changeScale = (val: number) => {
    let newVal = value + val;
    if (newVal > sliderProps.max) newVal = sliderProps.max;
    if (newVal < sliderProps.min) newVal = sliderProps.min;
    if (onChange) {
      onChange(newVal);
    }
  };

  // 处理图标点击事件
  const handleIconClick = (item) => {
    const { action, disable } = item;

    if (disable) return;

    if (action === "delete") {
      if (
        trackStore.selectGroupItem.line !== -1 &&
        trackStore.selectGroupItem.index !== -1
      ) {
        trackStore.removeGroup(
          trackStore.selectGroupItem.line,
          trackStore.selectGroupItem.index
        );
        trackStore.selectGroupItem.line = -1;
        trackStore.selectGroupItem.index = -1;
      }
    } else if (action === "undo") {
      console.log("do undo");

      undo();
    } else if (action === "redo") {
      redo();
    } else if (action === "SplitIcon") {
      // 判断分割时间是否在视频内
      // const splitTime = playerStore.playStartFrame;
      // const active =
      //   trackStore.trackList[trackStore.selectGroupItem.line].groups[
      //     trackStore.selectGroupItem.index
      //   ];
      // if (
      //   splitTime > active.start &&
      //   splitTime < active.end &&
      //   active.type === "video"
      // ) {
      //   const videoTrack = (active as any).split(splitTime);
      //   videoTrack.resize({
      //     width: playerStore.playerConfig.playerWidth,
      //     height: playerStore.playerConfig.playerHeight,
      //   });
      //   trackStore.addGroup(videoTrack);
      // }
    }
  };

  useEffect(() => {
    console.log("trackStore.trackList change");

    setState(trackStore.trackList);
  }, [trackStore.trackList]);

  return (
    <div
      className="pl-4 pb-1 pr-10 w-full h-10 border-b dark:border-darker border-gray-300"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 10px 2px 4px",
        width: "100%",
      }}
    >
      {/* 左侧图标区域 */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        {icons.map((item) => (
          <div key={item.title} onClick={() => handleIconClick(item)}>
            <item.icon style={{ padding: "0 6px", cursor: "pointer" }} />
          </div>
        ))}
      </div>

      <Button
        onClick={() => {
          console.log(trackStore.trackList);
        }}
      >
        打印结果
      </Button>

      {/* 右侧缩放控制区域 */}
      <div
        style={{
          width: 130,
          paddingRight: 12,
          display: "flex",
        }}
      >
        {/* <SubIcon
          style={svgStyle}
          className="cursor-pointer mr-4"
          onClick={() => changeScale(-10)}
        /> */}

        <Slider
          value={value}
          onChange={(val: number) => {
            onChange?.(val);
          }}
          {...sliderProps}
        />
        {/* <AddIcon
          style={svgStyle}
          className="cursor-pointer ml-4"
          onClick={() => changeScale(10)}
        /> */}
      </div>
    </div>
  );
};

export default observer(Toolbar);
